import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css';
import { VendorAuthProvider } from './context/VendorAuthContext';
import { SuperAdminAuthProvider } from './context/SuperAdminAuthContext';

import { HelmetProvider } from 'react-helmet-async';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <BrowserRouter>
        <VendorAuthProvider>
          <SuperAdminAuthProvider>
            <App />
          </SuperAdminAuthProvider>
        </VendorAuthProvider>
      </BrowserRouter>
    </HelmetProvider>
  </React.StrictMode>
);

reportWebVitals();
